import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError, LOGO_URL } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMessage(data.message);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-6">
      <div className="w-full max-w-sm rounded-md border border-slate-200 bg-white p-8 fade-in-up">
        <img src={LOGO_URL} alt="DCN" className="h-14 w-auto" />
        <h1 className="mt-4 text-xl font-bold text-slate-900">Forgot password</h1>
        <p className="mt-1 text-sm text-slate-500">
          Enter your email. A reset request will be created and your admin can share the reset link with you.
        </p>
        {message ? (
          <p data-testid="forgot-success-message" className="mt-6 rounded-md border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm text-emerald-700">
            {message}
          </p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Email</label>
              <input data-testid="forgot-email-input" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} placeholder="you@dcn.com"
                className="mt-1 w-full rounded-md border border-slate-300 px-3 py-2 text-sm outline-none transition-colors duration-150 focus:border-slate-900" />
            </div>
            {error && <p className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>}
            <button data-testid="forgot-submit-button" type="submit" disabled={loading}
              className="w-full rounded-md bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-slate-700 disabled:opacity-60">
              {loading ? "Submitting…" : "Request password reset"}
            </button>
          </form>
        )}
        <Link to="/login" data-testid="back-to-login-link" className="mt-4 block text-sm text-slate-500 underline-offset-4 hover:underline">
          ← Back to sign in
        </Link>
      </div>
    </div>
  );
}
